import type { FC } from 'react';
import { Avatar } from '../Avatar';
import love from './assets/love.png';
import * as Styled from './styled';
import type { MatchProps } from './types';

export * from './types';

export const Match: FC<MatchProps> = (props) => {
  const { buyerImage, breederImage } = props;

  return (
    <Styled.Container>
      <Avatar src={buyerImage} size={64} />
      <img src={love} alt="" width={48} />
      <Avatar src={breederImage} size={64} />
    </Styled.Container>
  );
};
